module.exports = __webpack_public_path__ + "img/top.d951bc56.svg";